<section class="page-control">
  <div class="flex justify-content-between w-full align-items-center">
    <h2 class="pt-1 pb-1">Online nalozi</h2>

    <button class="main-btn ml-4" (click)="onExportCsv()">
      Export CSV <i class="pi pi-file-excel"></i>
    </button>
  </div>
</section>

<app-table
  [tableHeader]="fieldsService.tableHeader"
  [tableData]="onlineNips.data"
  [loading]="loading"
  (handlePageChange)="onPageChange($event)"
  [paginator]="onlineNips.pagination"
  (handleSort)="onSort($event)"
>
</app-table>

<!-- PRODUCT DETAILS DIALOG ------------>
<p-dialog
  header="Detalji proizvoda"
  [(visible)]="showProductInfo"
  [modal]="true"
  [style]="{ width: '80vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
>
  <app-table
    [tableHeader]="fieldsService.productTableHeader"
    [tableData]="productInfo"
    [loading]="loading"
    (handlePageChange)="onPageChange($event)"
    [paginator]="false"
  >
  </app-table>
</p-dialog>

<!-- Final DETAILS DIALOG ------------>
<p-dialog
  header="Detalji završenog procesa"
  [(visible)]="showFinalDetailsInfo"
  [modal]="true"
  [style]="{ width: '80vw', height: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
>
  <p-table
    #dt1
    [value]="finalDetailsInfo"
    dataKey="id"
    [rows]="50"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
  >
    <ng-template pTemplate="header" let-item>
      <tr>
        <th *ngFor="let header of existOperations" style="padding: 0.5rem">
          {{ header.label }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-items>
      <tr *ngFor="let item of finalDetailsInfo; let index = index">
        <td
          *ngFor="let header of existOperations; let i = index"
          [ngClass]="createBackground(item[header?.label], i)"
        >
          <span>{{ item[header?.label].total_completed_percent }} %</span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10">Nema pronađenih prodataka.</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
<!-- 
[ngClass]="{
  'nip-background-priority-1':
    item[header?.label].total_completed_percent === 100,
  'nip-background-priority-2':
    item[header?.label].total_completed_percent !== 100
}" -->
